import { motion } from "framer-motion";

export const SeedMark = ({ size = 32, animated = false, className = "" }) => {
  const img = (
    <img
      src="/logo-seed.png"
      alt="Seed Imóveis"
      width={size}
      height={size}
      draggable={false}
      style={{ borderRadius: Math.round(size * 0.13), display: "block" }}
    />
  );

  if (!animated) {
    return (
      <div className={`shrink-0 ${className}`} data-testid="seed-mark">
        {img}
      </div>
    );
  }

  return (
    <motion.div
      className={`shrink-0 ${className}`}
      initial={{ scale: 0, rotate: -120, opacity: 0 }}
      animate={{ scale: 1, rotate: 0, opacity: 1 }}
      transition={{ duration: 1.1, ease: [0.16, 1, 0.3, 1], delay: 0.4 }}
      data-testid="seed-mark"
    >
      {img}
    </motion.div>
  );
};

export const Wordmark = ({ light = false, size = 32 }) => (
  <div className="flex items-center gap-3" data-testid="seed-wordmark">
    <SeedMark size={size} />
    <span
      className="font-heading font-bold tracking-tight"
      style={{ fontSize: size * 0.72, color: light ? "#F9F9F9" : "#004C3F" }}
    >
      Seed{" "}<span style={{ color: "#00D765" }}>Imóveis</span>
    </span>
  </div>
);
